import React from 'react';
import Spinner from '../Spinner/Spinner';
import styles from './Button.module.scss';
import classes from 'classnames/bind';

const cx = classes.bind(styles);

type TOnClickVoid = () => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TOnClickPromiseVoid = (event: any) => Promise<void>;

export interface ButtonProps {
  /**
   * Button children
   */
  children?: React.ReactNode;
  /**
   * Is this the principle call to action on the page?
   */
  primary?: boolean;
  /**
   * How large should the button be?
   */
  size?: 'small' | 'medium' | 'large' | 'full-width';
  /**
   * Shows spinning if true
   */
  loading?: boolean;
  /**
   * Optional click handler
   */
  onClick?: TOnClickVoid | TOnClickPromiseVoid;
  /**
   * Disable the button
   */
  disabled?: boolean;
  /**
   * Button type attribute
   */
  type?: 'button' | 'submit';
  /**
   * Can it occupy the space of its parent container
   */
  canGrow?: boolean;
  padding?: string;
  className?: string;
  color?: 'kale' | 'tomato' | 'blueberry' | 'grape' | 'curry';
}

/**
 * Primary UI component for user interaction
 */
const Button = ({
  children,
  primary = false,
  size = 'small',
  color = 'blueberry',
  loading = false,
  disabled = false,
  type = 'button',
  canGrow = false,
  padding,
  className,
  ...props
}: ButtonProps) => {
  const mode = primary ? 'primary' : 'secondary';
  return (
    <button
      disabled={disabled}
      type={type}
      className={cx('button', {
        [`${size}`]: size,
        'can-grow': canGrow,
        [`${className}`]: className,
        [`${color}-${mode}`]: true,
      })}
      style={{ padding }}
      {...props}
    >
      <span className={styles['content']}>
        <span
          className={cx({
            margin: loading,
          })}
        >
          {loading && <Spinner colour={primary ? 'salt' : color} />}
        </span>
        {children}
      </span>
    </button>
  );
};

export default Button;
